export const enum AccountsMatchingModeEnum {
    Single = 'single',
    Mass = 'mass',
}
